import { TreeNodeSerializer } from "../../../shared/models/serializers/treeNode.serializer";
import { TreeNode } from "../../../shared/models/treeNode.model";
import { getToken } from "../../../shared/utils/common";


export class CommandGetFolders{
    async run(organizationId: number) {
       
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/folders/?full_hierarchy=true`
            try {
                const response = await fetch(url, {
                    method: "GET",
                    headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `},
                    })
                .then(response =>  response.json())
                .then(json => json)
                .catch(err => console.log(err));
                if(response) {
                    return this.deserialize(response);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

    deserialize(data: any) : TreeNode [] {
        const serializer = new TreeNodeSerializer();
        return serializer.deserializeList(data);
    }

}
